/**
 * Сгенерировать объект ответа в формате расширения OpenAPI
 *
 * @see Api.Ext
 */
export const genExtRes = (
	result: any,
	errors?: Api.Ext.Schemas['ResponseError']['errors'],
	response?: Response,
): Api.Response<any> => {
	return {
		result,
		errors,
		response,
	};
};

/**
 * Это публичное API, к которому открыт доступ по прямой ссылке через GET
 *
 * Используется для кеширования и генерации файлов через API
 */
export const isPublicAPI = (path: Api.PathAbstract) => {
	return path.startsWith('/system_2/common/');
};

/**
 * Сгенерировать baseUrl на основе текущего домена
 */
export const getBaseDomainUrl = (useMainDomain = false, input: string = window.location.href, subdomain?: string) => {
	const { protocol, hostname, port } = new URL(input);

	/**
	 * localhost / IP-адреса / одноуровневые домены оставляем как есть
	 */
	const parts = hostname.split('.');
	const baseHostname = !useMainDomain || parts.length <= 2 || /^[\d.]+$/.test(hostname) || hostname === 'localhost'
		? hostname
		: parts.slice(-2).join('.');

	return `${protocol}//${baseHostname}${port ? `:${port}` : ''}`;
};
